import React from 'react';
import AppNavbar from './bootstrap/app-navbar';
import AppHeader from './bootstrap/app-header';
import AppFooter from './bootstrap/app-footer';
import AppFeatures from './bootstrap/app-features';
import AppContact from './bootstrap/app-contact';
import AppTestimonial from './bootstrap/app-testimonial';
import AppPricing from './bootstrap/app-pricing';
import AppHome from './bootstrap/app-home';

export default function BsContainer() {
  return (
    <>
      {/* <AppNavbar /> */}
      <AppHome />
      {/* <AppFooter /> */}
    </>
  );
}
